<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <h1 class="title">代理人注册</h1>
        <p class="subtitle">创建您的代理人账号以开始使用</p>
      </div>

      <el-form 
        :model="registerFrom" 
        :rules="rules" 
        ref="loginFromRef" 
        class="register-form"
        label-position="top">
        
        <el-form-item prop="email">
          <el-input 
            prefix-icon="el-icon-message"
            placeholder="请输入邮箱" 
            v-model="registerFrom.email" 
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            placeholder="至少6位密码，区分大小写"
            v-model="registerFrom.password"
            type="password"
            show-password
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="repassword">
          <el-input
            prefix-icon="el-icon-circle-check"
            placeholder="请再次确认密码"
            v-model="registerFrom.repassword"
            type="password"
            show-password
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <div class="captcha-container">
            <el-input
              prefix-icon="el-icon-key"
              placeholder="验证码"
              v-model="registerFrom.code"
              class="captcha-input"
              >
            </el-input>
            <div class="captcha-img" v-html="code" @click="getCode" title="点击更换验证码"></div>
          </div>
        </el-form-item>

        <div class="support-info">
          <p><i class="el-icon-warning-outline"></i> 若收不到邮件请联系管理 QQ: 58346871</p>
        </div>

        <div class="action-links">
          <span>已有账号？</span>
          <router-link to="/login">立即登录</router-link>
        </div>

        <el-form-item>
          <el-button type="primary" class="reg-btn" @click="register">注 册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // 邮箱自定义校验
    const checkEmail = (rule, value, cb) => {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) return cb();
      cb(new Error('请输入有效的邮箱地址'));
    };
    // 确认密码自定义校验
    const validatePass2 = (rule, value, cb) => {
      if (value === '') {
        cb(new Error('请再次输入密码'));
      } else if (value !== this.registerFrom.password) {
        cb(new Error('两次输入密码不一致!'));
      } else {
        cb();
      }
    };

    return {
      registerFrom: {
        email: "",
        password: "",
        repassword: "",
        code: "",
        type: "agent", // 保留代理人类型
        sign: ""
      },
      code: "",
      rules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: ["blur", "change"] },
          { min: 5, max: 40, message: "长度在 5 到 40 个字符", trigger: ["blur", "change"] },
          { validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 5, max: 16, message: "长度在 5 到 16 个字符", trigger: ["blur", "change"] },
        ],
        repassword: [
          { required: true, message: "请确认密码", trigger: ["blur", "change"] },
          { validator: validatePass2, trigger: 'blur' } // 修正为一致性校验
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
      },
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    async register() {
      this.$refs.loginFromRef.validate(async (valid) => {
        if (!valid) return this.$message.error("请完善注册信息");
        
        const res = await this.$http.post("registerAgent", this.registerFrom);
        if (res.data.meta.status !== 200) {
          this.getCode();
          return this.$message.error(res.data.meta.msg);
        } else {
          window.sessionStorage.setItem("registerAgent", this.registerFrom.email);
          this.$message.success("注册成功");
          return this.$router.push("/account/result");
        }
      });
    },
    async getCode() {
      let result = await this.$http.get('getcode?' + Date.parse(new Date()));
      this.code = result.data.img;
      this.registerFrom.sign = result.data.sign;
    },
    changeInput() {
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="less" scoped>
/* 核心容器：全屏居中+渐变背景 */
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

/* 注册卡片 */
.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
  }
}

/* 验证码布局 */
.captcha-container {
  display: flex;
  gap: 12px;
  .captcha-input { flex: 1; }
  .captcha-img {
    flex: 0 0 110px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    /deep/ div, /deep/ svg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

/* 提示信息样式 */
.support-info {
  margin: -10px 0 15px 0;
  p {
    font-size: 12px;
    color: #f56c6c;
    line-height: 1.4;
    margin: 0;
    i { margin-right: 4px; }
  }
}

/* 跳转链接 */
.action-links {
  text-align: right;
  margin-bottom: 20px;
  font-size: 14px;
  span { color: #606266; }
  a {
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
    &:hover { text-decoration: underline; }
  }
}

/* 注册按钮 */
.reg-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  letter-spacing: 4px;
  border-radius: 8px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15%;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}
</style>